/**
 * <compare-add-button> — toggle button on product cards that adds/removes
 * the product (by handle) from the comparison list in localStorage.
 * Keeps the header compare link badge in sync and reflects removals made
 * inside the popup via the `compare:updated` document event.
 */
if (!customElements.get('compare-add-button')) {
    class CompareAddButton extends HTMLElement {
        connectedCallback() {
            this.button = this.querySelector('button');
            if (!this.button) return;

            this.handle = this.button.dataset.productHandle;
            this.onClick = this.onClick.bind(this);
            this.refresh = this.refresh.bind(this);

            this.button.addEventListener('click', this.onClick);
            document.addEventListener('compare:updated', this.refresh);
            this.refresh();
        }

        disconnectedCallback() {
            this.button?.removeEventListener('click', this.onClick);
            document.removeEventListener('compare:updated', this.refresh);
        }

        getHandles() {
            try {
                return JSON.parse(CompareUtils.getCompareItems() || '[]');
            } catch (e) {
                return [];
            }
        }

        onClick(e) {
            e.preventDefault();
            e.stopPropagation();

            let handles = this.getHandles();
            if (handles.includes(this.handle)) {
                handles = handles.filter((h) => h !== this.handle);
            } else {
                handles.push(this.handle);
            }
            CompareUtils.setCompareItems(handles);
            document.dispatchEvent(new CustomEvent('compare:updated'));
        }

        refresh() {
            const active = this.getHandles().includes(this.handle);
            this.button.classList.toggle('is-active', active);
            this.button.setAttribute('aria-pressed', String(active));
            CompareAddButton.updateLink(this.getHandles().length);
        }

        static updateLink(count) {
            const link = document.getElementById(CompareUtils.compareLinkId);
            if (!link) return;
            link.classList.toggle('_active', count > 0);
            link.dataset.length = count;
            const badge = link.querySelector('.count');
            if (badge) {
                badge.textContent = count;
                badge.classList.toggle('hidden', count === 0);
            }
        }
    }

    customElements.define('compare-add-button', CompareAddButton);

    // Keep the header badge fresh on page load and after popup removals.
    document.addEventListener('compare:updated', () => {
        let count = 0;
        try {
            count = JSON.parse(CompareUtils.getCompareItems() || '[]').length;
        } catch (e) { /* ignore */ }
        CompareAddButton.updateLink(count);
    });

    document.addEventListener('DOMContentLoaded', () => {
        document.dispatchEvent(new CustomEvent('compare:updated'));
    });
}
